import React, { useContext } from 'react';
import { FileUploaderControlContext } from "../../FileUploaderControlContext";
import { ThemeContext } from "../../../../lib/theming/ThemeContext";
import { FileUploaderFile } from "../../FileUploaderFile/FileUploaderFile";
import { cx } from "../../../../lib/theming/Emotion";
import { useFileUploaderSize } from "../../hooks/useFileUploaderSize";
import { jsStyles } from "../FileUploaderFileList.styles";
export var FileUploaderFileDataTids = {
  fileList: 'FileUploader__fileList'
};
export var FileUploaderFileList = function FileUploaderFileList(props) {
  var renderFile = props.renderFile,
      size = props.size,
      onRemove = props.onRemove;

  var _useContext = useContext(FileUploaderControlContext),
      files = _useContext.files;

  var theme = useContext(ThemeContext);
  var fileWrapperClass = useFileUploaderSize(size, {
    small: jsStyles.fileWrapperSmall(theme),
    medium: jsStyles.fileWrapperMedium(theme),
    large: jsStyles.fileWrapperLarge(theme)
  });
  return /*#__PURE__*/React.createElement("div", {
    "data-tid": FileUploaderFileDataTids.fileList
  }, files.map(function (file) {
    return /*#__PURE__*/React.createElement("div", {
      key: file.id,
      className: cx(jsStyles.fileWrapper(theme), fileWrapperClass)
    }, /*#__PURE__*/React.createElement("div", {
      className: jsStyles.file()
    }, renderFile(file, /*#__PURE__*/React.createElement(FileUploaderFile, {
      file: file,
      showSize: true,
      multiple: true,
      size: size,
      onRemove: onRemove
    }))));
  }));
};
FileUploaderFileList.__KONTUR_REACT_UI__ = 'FileUploaderFileList';
FileUploaderFileList.displayName = 'FileUploaderFileList';